import { isEmpty } from 'lodash'
import React from 'react'
import { connect } from 'react-redux'
import { Row, Col } from 'reactstrap'

const UserAddress = ({
  user,
  data,
  itemAction,
}) => {
  return (
    <React.Fragment>
      {!isEmpty(data) && data.map((item, key) => (
        <div
          key={key}
          className="cart-card"
          onClick={() => itemAction(item.id)}
          style={{ cursor: 'pointer' }}
        >
          {item.default && (
            <div className="cart-card-check">
              <i className="mdi mdi-check-circle font-size-24" style={{ color: 'green' }}></i>
            </div>
          )}
          {!item.default && (
            <div className="cart-card-check">
              <i className="mdi mdi-check-circle-outline font-size-24"></i>
            </div>
          )}
          <Row style={{ marginBottom: '10px' }}>
            <Col sm="12"
              className="cart-card-font"
              style={{ alignSelf: 'center' }}
            >
              <div className="cart-user-address-card-subtitle">
                {user.firstName} {user.lastName}
              </div>
            </Col>
          </Row>
          <Row style={{ marginBottom: '10px' }}>
            <Col sm="12"
              className="cart-card-font"
              style={{ alignSelf: 'center', fontWeight: 300 }}
            >
              {`${item.calle} 
                ${item.numeroExterior} 
                ${item.numeroInterior} 
                ${item.colonia} 
                ${item.cp} 
                ${item.localidad} 
                ${item.municipio} 
                ${item.state && item.state.nomEstado} 
                ${item.country && item.country.nameEs}`}
            </Col>
          </Row>
        </div>
      ))}
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  return { user: state.Login.user }
}

export default connect(mapStatetoProps, {})(UserAddress)
